<template>
    <div>
        <reports-common-header
            :showPartition="true"
            @partitionSelected="onPartitionSelect"
            @rangeSelected="onRangeSelect"
            :reportType="reportType"
            :reportName="reportName"
        >
        </reports-common-header>

        <report-container>
            <template v-slot:reportContainer>
                <div>
                    <div class="report-page">
                        <div v-if="showInprogress">
                            <p class="text-center text-warning">Graph Loading....</p>
                        </div>
                        <div class="chart-wrapper" v-else-if="dataset.labels.length > 0">
                            <oee-chart :title="title" :dataset="dataset" :type="selectedPartition"/>
                        </div>
                        <div v-else>
                            <p style="text-align: center; color: red">No Data Found</p>
                        </div>
                    </div>
                    <div class="table-container y-scroll" v-if="showInprogress">
                        <p class="text-center text-warning">Table Loading....</p>
                    </div>
                    <div class="table-container y-scroll" v-else>
                        <report-table-by-station :reportType="reportTypeX" :stationId="reportPageFilters.selectedStationId"
                                                 :stationGroupId="reportPageFilters.selectedStationGroupId"
                                                 :start="selectedRange.start" :end="selectedRange.end" :type="selectedPartition"
                                                 v-if="selectedReportType==='station'"></report-table-by-station>
                        <report-table-by-product :reportType="reportTypeX" :stationId="reportPageFilters.selectedStationId"
                                                 :stationProductId="reportPageFilters.selectedStationProductId"
                                                 :stationGroupId="reportPageFilters.selectedStationGroupId"
                                                 :productGroupId="reportPageFilters.selectedProductGroupId" :start="selectedRange.start"
                                                 :end="selectedRange.end" :type="selectedPartition" v-if="selectedReportType==='product'"></report-table-by-product>
                        <report-table-by-shift :reportType="reportTypeX" :stationId="reportPageFilters.selectedStationId"
                                               :stationShiftId="reportPageFilters.selectedStationShiftId"
                                               :stationGroupId="reportPageFilters.selectedStationGroupId" :start="selectedRange.start"
                                               :end="selectedRange.end" :type="selectedPartition" v-if="selectedReportType==='shift'"></report-table-by-shift>
                        <!--<report-table-by-operator :reportType="reportTypeX" :stationId="reportPageFilters.selectedStationId" :stationOperatorId="reportPageFilters.selectedStationOperatorId" :start="selectedRange.start" :end="selectedRange.end" :type="selectedPartition" v-if="selectedReportType==='operator'"></report-table-by-operator>-->
                        <!--<report-table-by-team :reportType="reportTypeX" :stationId="reportPageFilters.selectedStationId" :stationTeamId="reportPageFilters.selectedStationTeamId" :start="selectedRange.start" :end="selectedRange.end" :type="selectedPartition" v-if="selectedReportType==='team'"></report-table-by-team>-->
                    </div>
                </div>
            </template>
        </report-container>

    </div>
</template>

<script>
import ReportsCommonHeader from './ReportsCommonHeader';
import ReportContainer from './ReportContainer';
import ReportFilters from './filters/ReportFilters';
import OEEChart from '../../components/reports/OEEChart';
import reportService from '../../services/Reports';
import ReportTableOEEByStation from './reporttable/oee/ReportTableOEEByStation';
import ReportTableOEEByProduct from './reporttable/oee/ReportTableOEEByProduct';
import ReportTableOEEByShift from './reporttable/oee/ReportTableOEEByShift';
import ReportTableOEEByOperator from './reporttable/oee/ReportTableOEEByOperator';
import ReportTableOEEByTeam from './reporttable/oee/ReportTableOEEByTeam';
import { mapState } from 'vuex';

export default {
    name: "OeeReport",
    props: {
        reportType: {
            type: String,
            default: 'station'
        },
        reportName: {
            type: String,
            default: 'oee'
        }
    },
    components: {
        ReportFilters,
        ReportContainer,
        'oee-chart': OEEChart,
        'report-table-by-station': ReportTableOEEByStation,
        'report-table-by-product': ReportTableOEEByProduct,
        'report-table-by-shift': ReportTableOEEByShift,
        'report-table-by-operator': ReportTableOEEByOperator,
        'report-table-by-team': ReportTableOEEByTeam,
        'reports-common-header': ReportsCommonHeader
    },
    data: () => ({
        selectedPartition: 'hourly',
        selectedRange: {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        },
        selectedReportType: 'station',
        selectedStation: null,
        selectedStationProduct: null,
        selectedStationShift: null,
        selectedStationOperator: null,
        selectedStationTeam: null,
        title: '',
        dataset: {
            labels: [],
            performance: [],
            availability: [],
            quality: [],
            oee: [],
        },
        tableData: [],
        reportNameX: 'OEE Report',
        reportTypeX: 'oee',
        showInprogress: false,
    }),
    computed:{
        reportTableTitle(){
            if(this.selectedReportType === 'station'){
                if(this.reportPageFilters.selectedStationId){
                    if(this.selectedStation) return `Station: ${this.selectedStation.name}`;
                    return '';
                } else {
                    return 'All Stations';
                }
            } else if(this.selectedReportType === 'product'){
                if(this.reportPageFilters.selectedStationProductId){
                    if(this.selectedStationProduct) return `Station: ${this.selectedStationProduct.station_name} > Product: ${this.selectedStationProduct.product_name}`;
                    return '';
                } else {
                    return 'All Products';
                }
            } else if(this.selectedReportType === 'shift'){
                if(this.reportPageFilters.selectedStationShiftId){
                    if(this.selectedStationShift) return `Station: ${this.selectedStationShift.station_name} > Shift: ${this.selectedStationShift.shift_name}`;
                    return '';
                } else {
                    return 'All Shifts';
                }
            } else if(this.selectedReportType === 'operator'){
                if(this.reportPageFilters.selectedStationOperatorId){
                    if(this.selectedStationOperator) return `Station: ${this.selectedStationOperator.station_name} > Operator: ${this.selectedStationOperator.operator_name}`;
                    return '';
                } else {
                    return 'All Operators';
                }
            }
        },
        ...mapState({
            reportPageFilters: 'reportPageFilters',
        })
    },
    methods: {
        onPartitionSelect(eventData) {
            this.selectedPartition = eventData;
            this.fetchOEEData();
        },
        onRangeSelect(eventData) {
            this.selectedRange.start = eventData.start;
            this.selectedRange.end = eventData.end;
            this.fetchOEEData();
            this.selectedRange.tag = "";
        },
        onReportTypeChange(eventData) {
            this.selectedReportType = eventData;
            this.fetchOEEData();
        },
        fetchOEEData() {
            this.showInprogress = true;
            const params = {
                stationId: this.reportPageFilters.selectedStationId || null,
                // F-03: keep the station-wise chart in step with its table when a
                // station group is selected. (Product/shift charts still use the
                // station endpoint — pre-existing; only the table is group-aware.)
                stationGroupId: this.reportPageFilters.selectedStationGroupId || null,
                start:     moment(this.selectedRange.start).format('DD-MM-YYYY'),
                end:       moment(this.selectedRange.end).format('DD-MM-YYYY'),
                type:      this.selectedPartition,
                reportType: this.reportTypeX
            };

            reportService.getOEETableReportByStation(params, responseData => {
                // 1) table
                this.tableData = responseData;

                // 2) chart
                this.dataset.labels       = responseData.map(r => r.time_duration);
                this.dataset.availability = responseData.map(r => r.availability * 100);
                this.dataset.performance  = responseData.map(r => r.performance  * 100);
                this.dataset.quality      = responseData.map(r => r.quality      * 100);
                this.dataset.oee          = responseData.map(r => r.oee          * 100);

                this.showInprogress = false;
            });
        },
    },
    watch: {
        reportType: function (newReportType, oldReportType) {
            this.selectedReportType = newReportType;
            this.fetchOEEData();
        },
        reportPageFilters: {
            handler(newFilters, oldFilters) {
                this.fetchOEEData();
            },
            deep: true
        }
    },
    mounted(){
        // F-03: filters now default to "All" and no longer auto-select a first
        // station, so the reportPageFilters watcher may not fire on load — fetch
        // the chart explicitly so the default (all/group) view renders immediately.
        this.fetchOEEData();
        this.$emit('reportNameX', this.reportNameX);
    }
}
</script>
